module.exports = __webpack_public_path__ + "img/amazon-logo.70fe5cf4.svg";